import { Injectable } from '@angular/core';

@Injectable()
export class TraceHelperService {
  populateTraceHeader = (action: any) => {
    return action.tracking?.tracing?.data?.traceContext;
  };
}
